import * as React from 'react';

/**
 * @ignore - internal component.
 */

function TwitterIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="117.8 161.3 464.4 377.4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#1da1f2"
        d="M582.2 206c-17 7.5-35.4 12.7-54.7 15a95.5 95.5 0 0 0 41.9-52.8 190.2 190.2 0 0 1-60.5 23.2A95.2 95.2 0 0 0 344 256.6a97.3 97.3 0 0 0 2.4 21.7c-79.2-4-149.4-42-196.4-99.6A95.2 95.2 0 0 0 179.6 306a95 95 0 0 1-43.1-11.9v1.2a95.3 95.3 0 0 0 76.4 93.5 96 96 0 0 1-25 3.3 96 96 0 0 1-18-1.7 95.3 95.3 0 0 0 89 66.1 191.2 191.2 0 0 1-141 39.5c42 27 92.1 42.8 146 42.8 175.2 0 271-145.2 271-271 0-4.2 0-8.3-.3-12.4a193.7 193.7 0 0 0 47.6-49.3z"
      />
    </svg>
  );
}

export default TwitterIcon;
